import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { RestService } from "app/webservice/rest.service";
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { ToastsManager } from "ng2-toastr";

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.css']
})
export class SetupComponent implements OnInit {
  public serviceStackUrl;
  public setupInfo = [];
  public currentPassword: String = '';
  public newPassword: String = '';
  public confirmNewPassword: String = '';
  
  public activeEdit = {
    LastUsed: '',
    BeginningRange: '',
    EndingRange: '',
    CheckoutDuration: '',
    Name: ''
  };

  @ViewChild('setupModal') setupModal;

  constructor(
    private route: Router, 
    private _restService: RestService, 
    private _toast: ToastsManager,
    platformLocation: PlatformLocation
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    this.findSetup();
  }

  ngOnInit() {
  }

  editInfo(info : any) {
    this.activeEdit = info;
    this.setupModal.show();
  }

  printBarcodePage(barcode : any) {
    console.log(barcode);
    this.route.navigate(['/printbarcode/', { RecordKey: barcode.RecordKey }]);
  }

  printOverdueReport(name : any) {
    this.route.navigate(['/overduereport/', { Type: name }]);
  }

  printSpineLabelPage(name : any) {
    console.log(name);
    this.route.navigate(['/spinelabel/', { Type: name }]);
  }

  updateInfo() {
    let url = this.serviceStackUrl + 'Admin-UpdateSetup';
    this._restService.post(url, {Data: this.activeEdit}).then(response => {
      this._toast.success('Successfully updated ' + this.activeEdit['Name']);
      this.activeEdit = {
        LastUsed: '',
        BeginningRange: '',
        EndingRange: '',
        CheckoutDuration: '',
        Name: ''
      };
      this.setupModal.hide();
    });
  }

  findSetup() {
    let url = this.serviceStackUrl + 'Admin-GetSetup';
    let setupObject = {};
    this._restService.post(url, setupObject).then(response => {
      for (var i = response.Data.length - 1; i >= 0; i--) {
        if (response.Data[i].Name === "Audio") {
          response.Data.splice(i, 1);
        }
        if (response.Data[i].Name === "Video") {
          response.Data[i].Name = 'DVD';
        }
      }
      this.setupInfo = response.Data;
    })
  }

  resetPassword() {
    if (this.newPassword === this.confirmNewPassword && this.newPassword != '') {
      let url = this.serviceStackUrl + 'Admin-ChangePassword';
      this._restService.post(url, {LoginName:"admin",OldPassword:this.currentPassword,NewPassword:this.newPassword}).then(response => {
        if (response.Success) {
          this._toast.success('Successfully reset password');
        } else {
          this._toast.error(response.Errors[0].Message);
        }
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmNewPassword = '';
      }).catch((err) => {
        console.log(err);
        this._toast.error('Error reseting password');
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmNewPassword = '';
      });
    } else if (this.newPassword != this.confirmNewPassword) {
      this._toast.error('Passwords do not match');
      this.currentPassword = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
    } else if (this.newPassword === '' || this.confirmNewPassword  === '') {
      this._toast.error('New password cannot be empty');
      this.currentPassword = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
    }
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/setup/setup.component.ts